import { PromiseActionContext, PromiseActions } from "../types";
import { internalApi } from "@consumer/services/api";
import { captureExceptionUnlessUnauthorized } from "./handleError";

export const getInternalApiCampaign = async (
  ctx: PromiseActionContext,
  payload: PromiseActions["getInternalApiCampaign"],
) => {
  ctx.commit("getInternalApiCampaignStart", null);

  try {
    const result = await internalApi.campaigns.get(payload.campaign_url_code);
    ctx.commit("internalApiCampaign/updateCampaign", result.data, {
      root: true,
    });
    ctx.commit("getInternalApiCampaignSuccess", result);
  } catch (error) {
    captureExceptionUnlessUnauthorized(error);

    ctx.dispatch("handleErrorWithSnackbar", error);
    ctx.commit("getInternalApiCampaignFailure");
  }
};
